module.exports = __webpack_public_path__ + "static/media/Dual_3343.67959cb3.jpg";